<template>
    <div class="md:pl-10 w-full md:pr-10">
        <template v-if="isReviewable">
            <h1 class="mt-2 mb-4 font-sans-bold">Submit resource details</h1>

            <p class="mb-6">
                When you have completed entering your resource information, please submit for review by the Reimagine team. Once the event is published and is live on the Reimagine Resources website, you will receive an email notification.
            </p>
            <p class="mb-6" ref="agree">
                By submitting my resource information, I acknowledge and agree: (A) that I have read and agree to the Reimagine Resources <a target="_blank" href="https://letsreimagine.org/terms-conditions">Terms &amp; Conditions</a> and (B) if I am submitting on behalf of an organization, I warrant that I am authorized by the organization to do so on its behalf.
            </p>
            <div class="mb-6">
                <div class="mb-12">
                    <div class="select-box flex-wrap">
                        <label class="text-base font-normal w-full">
                            <input type="checkbox"
                                v-validate="'required'"
                                v-model="agreeToTerms"
                                name="agree"
                            >
                            <span class="check inline-block mr-2"></span> I agree to terms for resource submission.
                        </label>
                        <span v-show="errors.has('agree')" class="error text-error-red text-lg w-full">{{ errors.first('agree') }}</span>
                    </div>
                </div>
                <button class="button mb-5" @click.stop.prevent="isSubmittable" :class="{ 'opacity-50 cursor-not-allowed': disableButton }" :disabled="disableButton">
                    <template v-if="saving">Processing...</template>
                    <template v-else>Submit for Review</template>
                </button>
            </div>
            <p class="mb-6">PLEASE NOTE: If you receive an error message upon clicking the submit button above, you have not sufficiently provided some information. Please review your resource and complete all the required fields.</p>
        </template>
        <template v-else>
            <h1 class="mb-6">Resource Status</h1>

            <p class="mb-6">
                <template v-if="resource.published">
                    Your resource has been published!
                </template>
                <template v-else-if="resource.status == 'unpublished'">
                    This resource has been unpublished by Reimagine staff.
                </template>
                <template v-else>
                    Your resource has been submitted for review!
                </template>
            </p>
        </template>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import messaging from "../../../mixins/messaging";
    import validation from "../../../mixins/validation";
    import {analyticsDataLayer} from "../../../api/analyticsDataLayer";

    export default {
        name: "ResourceCreateSubmit",
        mixins: [messaging, validation],
        data: () => ({
            submitted: false,
            agreeToTerms: false,
            saving: false
        }),
        computed: {
            ...mapGetters({
                resource: "resource",
                isLoading: "resourceIsLoading"
            }),
            isReviewable() {
                if (this.resource.published || this.submitted) {
                    return false;
                }

                if (
                    this.resource.status != "in review" &&
                    this.resource.status != "unpublished"
                ) {
                    return true;
                } else {
                    return false;
                }

                return true;
            },
            disableButton() {
                if (this.isLoading || this.saving) {
                    return true;
                }

                return false;
            }
        },
        methods: {
            submitResource() {
                let route = this.$laroute.route("api.resources.update.submit", {
                    resource: this.resource.id
                });

                axios
                    .put(route)
                    .then(response => {
                        this.$toasted.show(
                            "Resource has been submitted for review"
                        );
                        analyticsDataLayer.emit('resource_submitted_for_review');
                        this.submitted = true;
                        this.saving = false;
                        // this.$store.dispatch('setUnsavedData', false)
                    })
                    .catch(error => {
                        this.displayError(error);
                    });
            },

            isSubmittable() {
                this.saving = true;

                this.$validator.validateAll().then(result => {
                    if (!result) {
                        this.saving = false;
                        this.gotoFirstValidationError();
                        return;
                    }

                    let route = this.$laroute.route("api.resources.submittable", {
                        resource: this.resource.id
                    });

                    const form = this.resource;

                    axios
                        .post(route, form)
                        .then(response => {
                            this.$toasted.show(
                                "Resource being submitted for review..."
                            );
                            this.submitResource();
                        })
                        .catch(error => {
                            this.displayError(error);
                        });
                });
            }
        },
        mounted() {
            const id = this.$route.params.id;
            this.$store.dispatch("getResource", { id: id });
        }
    };
</script>
